import {
  buildPath,
  buildTemplatePath,
  CloseButton,
  Dialog,
  Divider,
  Grid,
  handleClose,
  Page,
  
  PageRoute,
  Typography,
  useParams,
} from "@compass/core";
import "moment-timezone";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type financialTableProps = {
  languageId: number;
};

export const FinancialTablePage = ({ languageId }: financialTableProps) => {
  useEffect(() => {}, []);

  return (
    <Grid container spacing="sm">
      <Grid item xs={12}>
        <Typography>
          {languageId === 1
            ? "To start, view how many are in your household, next see where your gross income falls on how often you are paid.  If your income is below that amount you qualify for Free/Reduced Lunch and may select yes. Military personnel do not need to include housing allowance when viewing income."
            : "Por favor revisa la tabla de abajo. Para comenzar, vea cuántos hay en su hogar, luego vea dónde cae su ingreso bruto en la frecuencia con la que se les paga. El personal militar no necesita incluir el subsidio de vivienda cuando informa los ingresos."}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing="sm">
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>{languageId === 2 ? "El número de personas que residen en mi hogar" : "Household Size"}</Grid>
              <Grid item xs={2}>{languageId === 2 ? "Año" : "Yearly"}</Grid>
              <Grid item xs={2}>{languageId === 2 ? "Mes" : "Monthly"}</Grid>
              <Grid item xs={2}>{languageId === 2 ? "Dos veces por mes" : "Twice Per Month"}</Grid>
              <Grid item xs={2}>{languageId === 2 ? "Cada dos semanas" : "Every Two Weeks"}</Grid>
              <Grid item xs={2}>{languageId === 2 ? "Seminal" : "Weekly"}</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>1</Grid>
              <Grid item xs={2}>28,953</Grid>
              <Grid item xs={2}>2,413</Grid>
              <Grid item xs={2}>1,207</Grid>
              <Grid item xs={2}>1,114</Grid>
              <Grid item xs={2}>557</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>2</Grid>
              <Grid item xs={2}>39,128</Grid>
              <Grid item xs={2}>3,261</Grid>
              <Grid item xs={2}>1,631</Grid>
              <Grid item xs={2}>1,505</Grid>
              <Grid item xs={2}>753</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>3</Grid>
              <Grid item xs={2}>49,303</Grid>
              <Grid item xs={2}>4,109</Grid>
              <Grid item xs={2}>2,055</Grid>
              <Grid item xs={2}>1,897</Grid>
              <Grid item xs={2}>949</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>4</Grid>
              <Grid item xs={2}>59,478</Grid>
              <Grid item xs={2}>4,957</Grid>
              <Grid item xs={2}>2,479</Grid>
              <Grid item xs={2}>2,288</Grid>
              <Grid item xs={2}>1,144</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>5</Grid>
              <Grid item xs={2}>69,653</Grid>
              <Grid item xs={2}>5,805</Grid>
              <Grid item xs={2}>2,903</Grid>
              <Grid item xs={2}>2,679</Grid>
              <Grid item xs={2}>1,340</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>6</Grid>
              <Grid item xs={2}>79,828</Grid>
              <Grid item xs={2}>6,653</Grid>
              <Grid item xs={2}>3,327</Grid>
              <Grid item xs={2}>3,071</Grid>
              <Grid item xs={2}>1,536</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>7</Grid>
              <Grid item xs={2}>90,003</Grid>
              <Grid item xs={2}>7,501</Grid>
              <Grid item xs={2}>3,751</Grid>
              <Grid item xs={2}>3,462</Grid>
              <Grid item xs={2}>1,731</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>8</Grid>
              <Grid item xs={2}>100,178</Grid>
              <Grid item xs={2}>8,349</Grid>
              <Grid item xs={2}>4,175</Grid>
              <Grid item xs={2}>3,853</Grid>
              <Grid item xs={2}>1,927</Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing="sm">
              <Grid item xs={2}>{languageId === 2 ? "Cada persona adicional" : "Each additional person"}</Grid>
              <Grid item xs={2}>10,175</Grid>
              <Grid item xs={2}>848</Grid>
              <Grid item xs={2}>424</Grid>
              <Grid item xs={2}>392</Grid>
              <Grid item xs={2}>196</Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div>
          {languageId === 1
          ? "This table is valid from July 1, 2025 to June 30, 2026. Source"
          : "Esta tabla es válida del 1 de julio de 2025 al 30 de junio de 2026. Fuente"}
          <a href="https://www.govinfo.gov/content/pkg/FR-2025-03-13/pdf/2025-03821.pdf">https://www.govinfo.gov/content/pkg/FR-2025-03-13/pdf/2025-03821.pdf</a>
        </div>
      </Grid>
    </Grid>
  );
};
